const TRACK_UPLOAD_INFO = "track-upload-info";
const PLAYER_QUEUE = "player-queue";

export { TRACK_UPLOAD_INFO, PLAYER_QUEUE };
